import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CustomerDeliveryAddressDto, CustomerAddressDto,
  CustomerAccountDto, OrderManagementCustomer,
  CustomerSearchFilterDto,
  PagedResultOfCustomerSearchDto,
  AjaxResponseOfCustomerConfigurationDto,
  AjaxResponseOfPagedResultOfCustomerAddressDto,
  CustomerConfigurationDto, AjaxResponseOfBoolean
} from '../shared/service-clients/om-customer';

@Injectable()
export class CustomerService {

  constructor(private omCustomer: OrderManagementCustomer) { }

  getCustomerAccountNumberList(): Observable<CustomerAccountDto[]> {
    return this.omCustomer.getCustomerAccountNumberList().pipe(map((x) => {
      return x.result;
    }, (e: any) => {
      console.log(e);
    }));
  }

  getCustomerDeliveryAddressList(orderId?: any): Observable<CustomerDeliveryAddressDto[]> {
    return this.omCustomer.getCustomerDeliveryAddress(orderId).pipe(map((x) => {
      return x.result;
    },
      (e: any) => {
        console.log(e);
      }));
  }

  getCustomerAddressList(customerId: any, pageSize: number, pageNumber: number, sortBy: string): Observable<AjaxResponseOfPagedResultOfCustomerAddressDto> {
    return this.omCustomer.getAllCustomerDeliveryAddress(customerId, pageSize, pageNumber, sortBy).pipe(map((x) => {
      return x;
    },
      (e: any) => {
        console.log(e)
      }));

  }


  getCustomerList(filter: CustomerSearchFilterDto): Observable<PagedResultOfCustomerSearchDto> {
    return this.omCustomer.searchCustomers(filter).pipe(map((x) => {
      return x.result;
    },
      (e: any) => {
        console.log(e);
      }));
  }

  getCustomerDetail(id: string): Observable<AjaxResponseOfCustomerConfigurationDto> {
    return this.omCustomer.getCustomerConfigurations(id)
  }

  setCustomerConfigurations(data: CustomerConfigurationDto): Observable<AjaxResponseOfCustomerConfigurationDto> {
    return this.omCustomer.setCustomerConfigurations(data)
  }
}